import { computed, Injectable, signal } from '@angular/core';

import type { UiError } from '../models/ui-error.models';
import { normalizeApiError, type NormalizeErrorOptions } from '../utils/error-normalizer';

@Injectable({ providedIn: 'root' })
export class GlobalFeedbackService {
  private readonly activeErrorValue = signal<UiError | null>(null);

  readonly activeError = computed(() => this.activeErrorValue());

  showError(error: UiError): void {
    this.activeErrorValue.set(error);
  }

  showNormalizedError(
    error: unknown,
    options: NormalizeErrorOptions & Pick<UiError, 'action' | 'actionLabel'> = {},
  ): UiError {
    const normalized = normalizeApiError(error, options);
    const merged: UiError = {
      ...normalized,
      action: options.action,
      actionLabel: options.actionLabel,
    };

    this.showError(merged);
    return merged;
  }

  clearError(): void {
    this.activeErrorValue.set(null);
  }

  runActiveAction(): void {
    const current = this.activeErrorValue();
    if (!current?.action) {
      return;
    }

    const action = current.action;
    this.clearError();
    action();
  }
}
